import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
import xhr from '../../core/xhr';
import {template, debounce, intersection} from 'lodash';
import inView from 'in-view';
import {stringify} from 'qs';
import noUiSlider from 'nouislider';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

export default class ImageGrid {
	constructor(el, options){

		this.page = 1;
		this.limit = 12;
		this.items = [];
		this.loading = false;
		this.options = options || null;

		this.dateMin = 0;
		this.dateMax = (new Date()).getFullYear();

		this.dateMinRange = 0;
		this.dateMaxRange = (new Date()).getFullYear();

		this.element = document.querySelector(el);
		this.more = $('#loadmore')

		this.changeFromCategory = false;

		this.init()
	}

	async init() {

		if (this.element) {
			this.$el = $(this.element);
			this.itemElement = document.querySelector('#istope-element').innerHTML;
			this.template = template(this.itemElement);
			this.grid = new Isotope( this.element, this.options);

			if ($('#bilder_search input.search-field').val().length) {
				$('#bilder_search .text').addClass('show-search');
				document.getElementById("grid").scrollIntoView({behavior: "smooth"});
			}

			$('#category-filter').on('change', 'input[type=checkbox]', () => {
				this.changeFromCategory = true;
				this.reset()
			});

			$('#filter-mode').on('change', 'input[type=checkbox]', () => {
				this.changeFromCategory = false;
				this.reset()
			});

			$('#chrono-sorting').on('change', 'input[type=checkbox]', () => {
				this.changeFromCategory = false;
				this.reset()
			});

			$('#reset-filter').on('click', () => {
				$('#category-filter input[type=checkbox]').prop("checked", false);
				$('#filter-mode input[type=checkbox]').prop("checked", false);
				$('#chrono-sorting input[type=checkbox]').prop("checked", false);
				$('#bilder_search input[name="search"]').val('');
				$('#bilder_search .text').removeClass('show-search');

				this.rangeSlider.noUiSlider.updateOptions({
						start: [this.dateMinRange, this.dateMaxRange],
					}
				);
				this.changeFromCategory = false;
				this.reset();
			});


			if (this.hash) {
				$('#category-filter input[value="'+this.hash+'"]').prop('checked', true);
			} 

			await this.reset();

			this.initRangeSlider();

			inView('#loadmore').on('enter', () => {
				this.next();
		    });

			$('#bilder_search input[name="search"]').on('keyup', debounce((e) => {
				if (e.originalEvent.key == 'Enter') {
					document.getElementById("grid").scrollIntoView({behavior: "smooth"});
				} else {
					this.changeFromCategory = false;
					this.reset();
				}
			}, 750));

			this.more.on('click', (e) => {
				e.preventDefault();
				if (! this.more.hasClass('is-loading')) {
					this.next();
				}
			});
						
			// Prevent submit on category view
			if (document.getElementById('category')) {
				$('#bilder_search form').on('submit', (e) => {
					e.preventDefault()
				})
			}		


		// Trigger image popup
		$('#gallerymodal').on('click', '.details-navigation a', function(e){
			e.preventDefault();
			
			var data_url = $(this).data('url');
			
			$('#gallerymodal').modal('toggle'); 
			
			// AJAX request
			$.ajax({
				url: data_url,
				type: "POST",
				dataType: "html",
				success: function(response){ 
			
				var responseArray = JSON.parse(response);
				$('.modal-body').html(responseArray.markup);
			
				const lightbox = new PhotoSwipeLightbox({
					gallery:'#popup-gallery > a',

					mouseMovePan: true,
					initialZoomLevel: 1,
					secondaryZoomLevel: 1,
					maxZoomLevel: 4,

					pswpModule: PhotoSwipe
				});

				setTimeout(() => {
					$('#gallerymodal').modal('show'); 
					lightbox.init();
				}, 500);
				}
			});
			});
			
			// Trigger image Next/Prev
			$('#category').on('click', '.grid__brick a', function(e){
			e.preventDefault();
			
			var data_url = $(this).data('url');
			
			// AJAX request
			$.ajax({
				url: data_url,
				type: "POST",
				dataType: "html",
				success: function(response){ 
			
				var responseArray = JSON.parse(response);
				$('.modal-body').html(responseArray.markup);

				$('#gallerymodal').modal('show'); 
				const lightbox = new PhotoSwipeLightbox({
					gallery:'#popup-gallery > a',

					mouseMovePan: true,
					initialZoomLevel: 1,
					secondaryZoomLevel: 1,
					maxZoomLevel: 4,
				
					pswpModule: PhotoSwipe
				});
				lightbox.init();
				}
			});
			});

		}
	}

	initRangeSlider() {

		var rangeSlider = document.getElementById('range-slider');

		noUiSlider.create(rangeSlider, {
			start: [this.dateMin, this.dateMax],
			connect: true,
			step: 1,
			range: {
				'min': this.dateMinRange,
				'max': this.dateMaxRange,
			}
		});

		var showValues = [
			document.getElementById('value-lower'),
			document.getElementById('value-upper')
		];

		showValues[0].innerHTML = this.dateMin;
		showValues[1].innerHTML = this.dateMax;
		
		rangeSlider.noUiSlider.on('update', function (values, handle) {
			showValues[handle].innerHTML = Math.round(values[handle]);
		});
		
		rangeSlider.noUiSlider.on('end', (values, handle) => {
			this.changeFromCategory = false;
			this.reset();
		});

		this.rangeSlider = rangeSlider;

	}

	next() {

		return new Promise(async (resolve) => {

			if (!this.loading) {	
				this.loading = true;
				this.more.addClass('is-loading');

				var result;
				try {
					result = await this.load();
				} catch (error) {
					console.error(error);
					this.loading = false;
					this.more.removeClass('is-loading');
					return resolve();
				}

				if (result['dateMin']) {
					this.dateMin = result['dateMin'];
				}
				if (result['dateMax']) {
					this.dateMax = result['dateMax'];
				}

				this.dateMinRange = result['dateMinRange'];
				this.dateMaxRange = result['dateMaxRange'];

				if (result['dateMin'] || result['dateMax']) {
					this.rangeSlider && this.rangeSlider.noUiSlider.updateOptions({
						start: [this.dateMin, this.dateMax],
					});
				}

				let items = this.render(result['imageValues']);
	
				this.updateCounter(result);
	
				this.items.push(...items);
	
				items.forEach((item) => {
					this.$el.append(item);
					this.grid.appended(item);
				});
	
				! items.length && this.more.addClass('d-none');

				imagesLoaded( this.element ).on( 'progress', () => this.layout());
	
				this.page++;
	
				this.loading = false;
				this.more.removeClass('is-loading');
			}

			resolve();

		});

	}

	layout() {
		this.grid.layout();
	}

	reset() {

		this.page = 1;
		this.grid.destroy();
		this.$el.empty();
		this.more.removeClass('d-none');

		this.grid = new Isotope( this.element, this.options);

		this.items = [];

		return this.next();
	}

	render(items) {

		var range = this.rangeSlider ? this.rangeSlider.noUiSlider.get() : null;

		let searchQuery = this.query
		if(searchQuery.substring(0, 1) == '#') {
			searchQuery = '';
		}

		let qs = stringify({
			categories: this.categories,
			search: searchQuery,
			chronosorting: this.chronoSorting,
			range
		})

		return items.map((item) => {
			let categoryid = this.getImageCategory(item)
			item.link = `/detail/${item.seo}?${qs}`
			item.linkpopup = `/detailpopup/${item.seo}?${qs}`

			let $item = $(this.template(item))

			this.preload($item, item.thumb)

			return $item;
		} );
	}

	async load() {
		return new xhr(this.filter).post('/entdecken/images');
	}

	updateCounter(result) {
		$('#image_count span').html(result['countImages']);
	}


	preload($el, src) {
		$el.find('.preloader').addClass('d-block');

		let img = document.createElement('img')
		img.onload = () => {
			$el.find('.image > img').attr('src', src)
			$el.find('.preloader').removeClass('d-block');
			this.layout();
		}
		img.src = src
	}

	getImageCategory(image) {

		if (this.categories.length) {
			let imagecategories = image.categories.map(function(elem) {
				return elem.id;
			});
			let categoryintersection = intersection(imagecategories, this.categories);

			return categoryintersection.shift();
		} else {
			return image.categories.slice(0).shift().id;
		}
	}

	get filter() {

		var range = this.rangeSlider ? this.rangeSlider.noUiSlider.get() : null;

		return {
			page: this.page,
			limit: this.limit,
			categories: this.categories,
			search: this.query,
			filtermode: this.filterMode,
			chronosorting: this.chronoSorting,
			changeFromCategory: this.changeFromCategory,
			range,
		}
	}

	get categories() {
		var categories = [];

		$('#category-filter input[type=checkbox]').each( ( i, elem ) => {
			if ( elem.checked ) {
				categories.push( parseInt(elem.value) );
			}
		});

		return categories;
	}

	get filterMode() {
		var filtermode = 0;

		$('#filter-mode input[type=checkbox]').each( ( i, elem ) => {
			if ( elem.checked ) {
				filtermode = 1;
			}
		});

		return filtermode;
	}

	get chronoSorting() {
		var chronosorting = 0;

		$('#chrono-sorting input[type=checkbox]').each( ( i, elem ) => {
			if ( elem.checked ) {
				chronosorting = 1;
			}
		});

		return chronosorting;
	}

	get query() {
		return $('#bilder_search input[name="search"]').val();
	}

	get hash() {
		return window.location.hash.length ? window.location.hash.replace("#", "") : null;
	}
}

